<template>
    <ui-modal>
        <template #header>
            <h3 class="mb-1 text-center" v-text="'Zgłoszenie integracji'" />
            <h5 class="mb-0 text-center text-danger" v-text="'Informacja'" />
        </template>

        <div>
            <p class="text-center">
                <a-icon
                    class="text-warning"
                    width="40px"
                    height="40px"
                    icon="WarningFull"
                />
            </p>
            <p class="text-primary">
                <strong v-text="'Uwaga!'" />
                W następnym kroku dokonasz wyboru serwisu kas fiskalnych, który otrzyma
                zlecenie instalacji zakupionych dostępów w Twoich sklepach.

                <br />
                <br />
                Ta usługa zostanie rozliczona według obowiązujących stawek (aktualne stawki znajdziesz w sekcji
                <router-link class="text-underline" :to="{ name: 'help' }" target="_blank">Pomoc</router-link>).

            </p>

            <ui-checkbox-input
                class="text-sm"
                name="dealer-warning"
                :label="`
                    Potwierdzam, że zapoznałem/am się z powyższą informacją
                    i mam świadomość dodatkowych kosztów instalacji Systemu Kaucyjnego
                    w moich sklepach<span class='text-danger'>*</span>
                `"
                :value="isConfirmed"
                @change="isConfirmed = $event"
            />
        </div>

        <template #footer>
            <the-btn
                class="btn-outline-custom"
                text="Wróć"
                @click="$emit('close-modal')"
            />
            <the-btn
                :disabled="!isConfirmed"
                class="btn-secondary"
                text="Przejdź do wyboru serwisu"
                @click="isConfirmed && $store.dispatch('openModal', {
                    componentPath: 'drs/configuration/SelectDealer'
                })"
            />
        </template>
    </ui-modal>
</template>

<script>
export default {
    data: () => ({
        isConfirmed: false
    })
}
</script>